import { render, staticRenderFns } from "./tipsemployee.vue?vue&type=template&id=5d600fea&scoped=true"
import script from "./tipsemployee.vue?vue&type=script&lang=js"
export * from "./tipsemployee.vue?vue&type=script&lang=js"
import style0 from "./tipsemployee.vue?vue&type=style&index=0&id=5d600fea&prod&lang=scss&scoped=true"
import style1 from "./tipsemployee.vue?vue&type=style&index=1&id=5d600fea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d600fea",
  null
  
)

export default component.exports